import { render, staticRenderFns } from "./EnacAtplDashboardRegistrationsSearch.vue?vue&type=template&id=112968e0"
import script from "./EnacAtplDashboardRegistrationsSearch.vue?vue&type=script&lang=js"
export * from "./EnacAtplDashboardRegistrationsSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports